export { default as EventSessionsApp } from '../EventSessionsApp';
